<template>
  <base-layout
    :menu-items="menuItems"
    :class="{ 'gs-product-wizard-layout': $route.meta.hideHeaderBar }"
  >
    <template slot="content">
        <div class="w-full h-full" :class="{ 'pb-5 pt-3 pl-6 pr-4': hasPadding }">
          <div
            :class="{ 'container mx-auto': !fullWidth, 'h-full': fullHeight }"
          >
            <transition :name="routerTransition">
              <router-view :key="$route.fullPath"></router-view>
            </transition>
          </div>
        </div>
    </template>
    <template slot="header-bar">
      <header-bar
        v-if="!$route.meta.hideHeaderBar && ($route.meta.breadcrumb || $route.meta.pageTitle)"
        :route-title="routeTitle"
      ></header-bar>
      <div
        v-else-if="$route.meta.hideHeaderBar"
        class="gs-product-wizard-header-slot"
      >
        <funnel-studio-breadcrumb v-if="studioReturn" />
        <portal-target v-else
          name="headerBreadCrumb"
          class="gs-product-wizard-header-slot__breadcrumb"
        ></portal-target>
        <portal-target
          name="headerContent"
          class="gs-product-wizard-header-slot__content"
        ></portal-target>
      </div>
    </template>
    <template v-if="hasSidebar" slot="sidebar">
      <sidebar-menu v-if="sidebar == 'default'"></sidebar-menu>
      <sidebar-affiliate-menu
        v-if="sidebar == 'affiliates'"
      ></sidebar-affiliate-menu>
    </template>
  </base-layout>
</template>

<script>
import BaseLayout from '../design-system/account-adapter';
import FunnelStudioBreadcrumb from '@/components/FunnelStudioBreadcrumb.vue';
import { funnelStudioReturn } from '@/router/utils/funnel-studio-context';

export default {
  components: {
    BaseLayout, FunnelStudioBreadcrumb
  },
  props: {
    sidebar: {
      type: String,
      default: 'default'
    },
    hasPadding: {
      type: Boolean,
      default: true
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExternal: true,
      showSlider: false,
      routerTransition: 'zoom-fade',
      routeTitle: this.$route.meta.pageTitle,
      isAdmin: null
    };
  },
  computed: {
    studioReturn() { return funnelStudioReturn(this.$route); },
    menuItems() {
      return [];
    },
    hasSidebar() {
      return this.sidebar !== 'none';
    }
  },

  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    }
  },
  async created() {
    this.isAdmin = this.$store.state.user.admin;
  },

  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    }
  }
};
</script>

<style>
.gs-product-wizard-layout > .flex.flex-row.w-full.bg-white.h-13 {
  justify-content: center;
}

.gs-product-wizard-layout > .flex.flex-row.w-full.bg-white.h-13 > .flex.flex-grow {
  flex: 0 1 1240px;
  max-width: 1240px;
  padding-right: 28px;
  padding-left: 28px;
}

.gs-product-wizard-layout > .flex.flex-row.w-full.bg-white.h-13 > .w-16 {
  border-right: 0;
}

.gs-product-wizard-layout > .flex.flex-row.w-full.bg-white.h-13 > .w-13 {
  border-left: 0;
}

.gs-product-wizard-header-slot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 64px;
}

.gs-product-wizard-header-slot__breadcrumb,
.gs-product-wizard-header-slot__content {
  display: flex;
  align-items: center;
}

.gs-product-wizard-header-slot__content {
  justify-content: flex-end;
  margin-left: auto;
}

.modified-scrollbars {
  height: calc(100vh - 4rem) !important;
  scrollbar-color: #999 #eee;
  scrollbar-width: thin;
}
</style>
